export default __webpack_public_path__ + "static/media/couponremove.00302aae.svg";